<template>
  <div id="data-list-list-view" class="data-list-container">
    <AddNewDataSidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluido"
    />

    <ModalRepostaAgravo ref="ModalRepostaAgravo" @close="closePopUp" />

    <ModalRepostaAgravoVida ref="ModalRepostaAgravoVida" @close="closePopUp" />

    <vs-table
      noDataText="Nenhuma Tabela Encontrada"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="activate"
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="disable"
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>

          <!------------ START ADD NOVO AGRAVO -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between font-medium text-base text-primary border border-solid border-primary"
            @click="openSideBar()"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar novo Agravo</span
            >
          </div>
          <!------------ END NOVO AGRAVO -->
        </div>

        <!------------ START ITENS POR PÁGINA -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itens.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itens.length
              }}
              de {{ itens.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!------------ END ITENS POR PÁGINA -->
      </div>
      <!------------ START TITULO DA TABELA ------------>
      <template slot="thead">
        <vs-th sort-key="apolice">Tipo de apólice</vs-th>
        <vs-th sort-key="pergunta">Pergunta</vs-th>
        <vs-th>Respostas</vs-th>
        <vs-th sort-key="grupoComum">Aplicado a todos os grupos?</vs-th>
        <vs-th>Grupos Específicos</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>
      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.apolice }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.pergunta }}</p>
            </vs-td>
            <vs-td>
              <div
                :key="indextd"
                v-for="(item, indextd) in tr.respostas"
                class="flex justify-between items-center mb-2"
              >
                <p class="product-category">
                  {{ item.resposta }}
                </p>
                <div>
                  <vs-button
                    radius
                    v-tooltip="'Editar'"
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline"
                    @click="openPopUpResposta(tr, item)"
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                  ></vs-button>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getColor(tr.grupoComum)"
                class="product-order-status"
                >{{ getSimNao(tr.grupoComum) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p
                :key="indextd"
                v-for="(item, indextd) in tr.nomesGrupos"
                class="product-category"
              >
                {{ item }}
              </p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getColorByDeletedat(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusByDeletedat(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <div style="width: 350px">
                <vs-button
                  radius
                  v-tooltip="'Editar'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="openSideBar(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
                <vs-button
                  radius
                  v-tooltip="'Adicionar nova resposta'"
                  color="primary"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="d-inline"
                  @click="openPopUpResposta(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
      <!------------ END TABELA ------------>
    </vs-table>
  </div>
</template>
<script>
import AddNewDataSidebar from '../../../Includes/SideBar.vue';
import ModalRepostaAgravo from './modalRepostaAgravo.vue';
import ModalRepostaAgravoVida from './modalRespostaAgravoVida.vue';

import utilsList from '../../../../utils/list/index';
import notify from '../../../../utils/notify';
import services from '../../../../services';
import { TIPOS_APOLICES } from '../../../../utils/constants';

export default {
  name: 'list-agravos-proposta',
  components: { AddNewDataSidebar, ModalRepostaAgravo, ModalRepostaAgravoVida },
  props: ['subjectPermission'],
  data() {
    return {
      getColorByDeletedat: utilsList.getColorAtivoInativoByDeletedAt,
      getStatusByDeletedat: utilsList.getAtivoInativoByDeletedAt,
      getSimNao: utilsList.getSimNao,
      getColor: utilsList.getColorAtivoInativo,
      itemsPerPage: 50,
      currentPage: 1,
      selected: [],
      itens: [],
      formSideBar: 'AgravoProposta',
      entidade: 'Agravo',
      titleSideBar: 'Adicionar Agravo',
      dadosSideBar: null,
      addNewDataSidebar: false,
      keyId: 'idAgravo',
      activeModal: false,
      dadosResposta: {},
    };
  },
  mounted() {
    this.getAgravosProposta();
  },
  methods: {
    async getAgravosProposta() {
      try {
        const controller = 'agravos';
        const action = 'agravos-proposta';
        this.$vs.loading();

        const { data } = await services.getAll(controller, null, action);
        this.itens = data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async activate() {
      const action = 'agravos-proposta/reativar';
      this.activeDisableAgravoCep(action);
      this.selected = [];
    },
    async disable() {
      const action = 'agravos-proposta/inativar';
      this.activeDisableAgravoCep(action);
      this.selected = [];
    },
    async activeDisableAgravoCep(action) {
      const result = await utilsList.inativarRegistros(
        this.$vs,
        this.selected,
        this.keyId,
        'agravos',
        action,
      );

      if (result) {
        this.getAgravosProposta();
      }
    },
    openPopUpResposta(item, tr) {
      const { idAgravo, idTipoApolice } = item;

      if (idTipoApolice === TIPOS_APOLICES.VIDA) {
        this.$refs.ModalRepostaAgravoVida.open({ idAgravo, ...tr });
        return;
      }

      this.$refs.ModalRepostaAgravo.open({ idAgravo, ...tr });
    },
    openSideBar(tr) {
      this.titleSideBar = `Adicionar ${this.entidade} `;

      if (tr !== null) {
        this.titleSideBar = `Editar dados do ${this.entidade}`;
      }

      this.dadosSideBar = tr;
      this.addNewDataSidebar = true;
    },
    concluido() {
      this.getAgravosProposta();
    },
    closePopUp(buscar) {
      this.activeModal = false;
      if (buscar) {
        this.getAgravosProposta();
      }
    },
  },
};
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}
</style>
